module.exports = __webpack_public_path__ + "img/twitter.bcde943e.svg";